import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { TextField, MenuItem, Select, InputLabel, FormControl, OutlinedInput,} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare } from '@fortawesome/free-solid-svg-icons';
import '../css/usermain.css';
import AddTaskPopup from './AddTaskPopup';
import AcademicGuruLogo from '../assets/academicguru.png';
import LeelagreenLogo from '../assets/leelagreen.jpg';
import AGPHLogo from '../assets/agph.png';
import IJISEMLogo from '../assets/ijisem.png';
import { motion } from 'framer-motion';
import ProjectSidebar from '../UserComponents/ProjectSidebar';

const ITEMS_PER_PAGE_OPTIONS = [20, 50, 100];


const ProjectTableTabs = () => {
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
    const [categories, setCategories] = useState([]);
        const [showPopup, setShowPopup] = useState(false);
        
     
        

    

  useEffect(() => {
    axios.get('/api/categories.php')
      .then(res => setCategories(res.data))
      .catch(err => console.error(err));
  }, []);


  const [formData, setFormData] = useState({
    projectName: '',
    client: '',
    category: '',
    submisssion_date: '',
    company_name: '',
    assign_to: '',
    members: []
  });

  const [userOptions, setUserOptions] = useState([]);
  

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get("/api/users.php");
        setUserOptions(res.data);
      } catch (error) {
        console.error("Failed to load users:", error);
      }
    };

    fetchUsers();
  }, []);

 const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const url = isEdit
      ? `/api/projects.php?project_id=${editingId}`
      : '/api/projects.php';

    const method = isEdit ? 'PUT' : 'POST';

    const res = await fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (res.ok) {
      alert(isEdit ? 'Project updated successfully!' : 'Project saved successfully!');
      setFormData({
        projectName: '',
        client: '',
        category: '',
        submisssion_date: '',
        company_name: '',
        assign_to: '',
        members: []   // ✅ Include members to reset properly
      });
      setShowModal(false);
      setIsEdit(false);
      setEditingId(null);
      window.location.reload();
    } else {
      alert('Error saving project');
    }
  } catch (error) {
    console.error('Error:', error);
    alert('Failed to submit');
  }
};


  const handleEditProject = (project) => {
    setFormData({
      projectName: project.name,
      client: project.client,
      category: project.category,
      submisssion_date: project.submisssion_date,
      assign_to: project.assign_to,
      company_name: project.company_name,
      status: project.status,
      members: project.members || []
    });
    setEditingId(project.id);
    setIsEdit(true);
    setShowModal(true);
  };
  // Helper to convert ISO to local date string (YYYY-MM-DD)
const toLocalDate = (isoString) => {
  const date = new Date(isoString);
  const offset = date.getTimezoneOffset();
  date.setMinutes(date.getMinutes() - offset); // neutralize timezone
  return date.toISOString().split('T')[0];
};

  return (
    <div className="p-9">
        <div className="search shadow-xl ">
          <input
            className="search_input"
            type="text"
            placeholder="Search here..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value.toLowerCase())}
          />
          <a href="#/" className="search_icon" onClick={e => e.preventDefault()}>
            <i className="fa fa-search"></i>
          </a>
        </div>
      <div className="justify-end mb-3 text-right">
        <button
          onClick={() => setShowPopup(true)}
          className='bg-white p-4 pt-1 pb-1 rounded shadow-xl font-semibold text-gray-500'
        >
          <span className='text-red-400 text-lg'>+</span> Add 
        </button>
      </div>
      {showPopup && <AddTaskPopup onClose={() => setShowPopup(false)} />}
      <ProjectTable onEdit={handleEditProject} searchQuery={searchQuery}/>
      {/* The modal code follows (already included above) */}
       {showModal && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-b backdrop-blur-sm from-blue-10 to-black">
                <div className="bg-white rounded-lg shadow-lg w-[800px] max-w-2xl p-6 relative">
                  <h2 className="font-semibold mb-4 text-center text-xl pb-7">New Project</h2>
                  <form className="space-y-7" onSubmit={handleSubmit}>
                    <div className="flex gap-4">
        <TextField
        id="project-name"
        label="Project Name"
        variant="outlined"
        fullWidth
        
        value={formData.projectName}
        onChange={(e) =>
          setFormData({ ...formData, projectName: e.target.value })
        }
      />
      
        <TextField
          id="client"
          label="Client"
          variant="outlined"
          fullWidth
          value={formData.client}
          onChange={(e) => setFormData({ ...formData, client: e.target.value })}
        />
      </div>
      <div className="flex gap-4">
          <FormControl fullWidth variant="outlined" >
            <InputLabel id="category-label">Category</InputLabel>
            <Select
              labelId="category-label"
              id="category"
              value={formData.category}
              label="Category"
              onChange={(e) => setFormData({ ...formData, category: e.target.value })}
            >
              {categories.map((cat) => (
                <MenuItem key={cat.id} value={cat.category_name}>
                  {cat.category_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            id="company_name"
            label="Company"
            variant="outlined"
            select
            fullWidth
            value={formData.company_name}
            onChange={(e) => setFormData({ ...formData, company_name: e.target.value })}
          >
            {["AGPH", "Leela Greens", "Academic Guru", "IJISEM"].map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
      </div>
      <div className="flex gap-4">
        <FormControl fullWidth>
  <InputLabel id="members-label">Manager By</InputLabel>
  <Select
    labelId="assign_to-label"
    id="assign_to"
    value={formData.assign_to}
    onChange={(e) => setFormData({ ...formData, assign_to: e.target.value })}
    input={<OutlinedInput label="Manager By" />}
  >
    {userOptions.map((user) => (
      <MenuItem key={user.name} value={user.name}>
        {user.name}
      </MenuItem>
    ))}
  </Select>
</FormControl>
      
<TextField
  type="date"
  id="submisssion_date"
  label="Deadline"
  variant="outlined"
  fullWidth
  value={formData.submisssion_date ? toLocalDate(formData.submisssion_date) : ""}
  onChange={(e) =>
    setFormData({ ...formData, submisssion_date: e.target.value })
  }
  InputLabelProps={{
    shrink: true,
  }}
/>
      </div>
      
        <div className="flex justify-end gap-2 pt-4">
          <button
            type="button"
            onClick={() => setShowModal(false)}
            className="px-4 py-2 rounded border border-gray-300 text-gray-700 hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
          >
            Save
          </button>
        </div>
      </form>
                  <button
                    onClick={() => setShowModal(false)}
                    className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl"
                  >
                    ×
                  </button>
                </div>
              </div>
            )}
    </div>
  );
};

const ProjectTable = ({  onEdit, searchQuery }) => {
  const [projects, setProjects] = useState([]);
  const [userMap, setUserMap] = useState({});
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("desc");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [userprojectOptions, setUserprojectOptions] = useState([]);
  const [projectRunningMap, setProjectRunningMap] = useState({});
     const [selectedProject, setSelectedProject] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeRow, setActiveRow] = useState(null);


  const handleRowClick = (project) => {
    setSelectedProject(project);
    setSidebarOpen(true);
  };

useEffect(() => {
  const fetchTasks = async () => {
    try {
      const res = await axios.get("/api/tasks.php");
      const tasks = res.data;

      const map = {};

      tasks.forEach(task => {
        const pid = task.project_id;
        const durations = JSON.parse(task.duration || '[]');
        const last = durations[durations.length - 1];

        const isRunning = last && last.start && !last.end && !last.pause;

        if (isRunning) {
          map[pid] = true; // Mark this project_id as running
        }
      });

      setProjectRunningMap(map);
    } catch (error) {
      console.error("Failed to fetch tasks for running status:", error);
    }
  };

  fetchTasks();
}, []);
  


  
  

  useEffect(() => {
    const fetchUsersproject = async () => {
      try {
        const res = await axios.get("/api/users.php");
        setUserprojectOptions(res.data);
      } catch (error) {
        console.error("Failed to load users:", error);
      }
    };

    fetchUsersproject();
  }, []);

useEffect(() => {
  const fetchProjects = async () => {
    try {
      const res = await axios.get("/api/projects.php");
      
      const formatted = res.data.map(project => ({
        ...project,
        members: project.team_members, // already an array from PHP
        updated: '1h ago', // optional mock value
        progress: Math.floor(Math.random() * 100), // optional mock value
      }));

      setProjects(formatted);
    } catch (error) {
      console.error("Failed to load projects:", error);
    }
  };

  fetchProjects();
}, []);



  useEffect(() => {
  const fetchUserNames = async () => {
    try {
      const res = await axios.get("/api/useroptions.php");
      const map = {};
      res.data.forEach(user => {
        map[user.id] = user.name; // 🔄 changed from user.user_id to user.id
      });
      setUserMap(map);
    } catch (error) {
      console.error("Failed to load user names:", error);
    }
  };
  fetchUserNames();
}, []);


  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this project?")) return;
    try {
      await axios.delete(`/api/projects.php?id=${id}`);
      setProjects(prev => prev.filter(p => p.id !== id));
    } catch (error) {
      console.error("Delete failed:", error);
      alert("Failed to delete project.");
    }
  };

  const handleEdit = (project) => {
    onEdit(project);
  };

 const filtered = projects.filter(p => {
  const query = searchQuery.toLowerCase().trim();

  // Always include all projects when searching
  if (query) {
    return (
      p.project_id.toLowerCase().includes(query) ||
      p.name.toLowerCase().includes(query) ||
      p.client.toLowerCase().includes(query) ||
      p.assign_to.toLowerCase().includes(query) ||
      p.category.toLowerCase().includes(query)
    );
  }

  // If no search, exclude 'Done'
  return p.status !== "Done";
});

  const sortedProjects = [...filtered].sort((a, b) => {
    const valA = a[sortField];
    const valB = b[sortField];
    if (typeof valA === "string") {
      return sortOrder === "desc" ? valA.localeCompare(valB) : valB.localeCompare(valA);
    } else {
      return sortOrder === "desc" ? valA - valB : valB - valA;
    }
  });

  const totalPages = Math.ceil(sortedProjects.length / itemsPerPage);
  const paginatedProjects = sortedProjects.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const handleSort = (field) => {
    const isAsc = sortField === field && sortOrder === "desc";
    setSortOrder(isAsc ? "desc" : "asc");
    setSortField(field);
  };
  const navigate = useNavigate();
  const renderTaskStatusSquares = (taskCountJson) => {
  let parsed = {
    "Hold": 0,
    "To Do": 0,
    "Doing": 0,
    "Done": 0
    
  };

  try {
    if (typeof taskCountJson === 'string') {
      const temp = JSON.parse(taskCountJson);
      parsed = { ...parsed, ...temp };
    } else if (typeof taskCountJson === 'object' && taskCountJson !== null) {
      parsed = { ...parsed, ...taskCountJson };
    }
  } catch (e) {
    // fail silently
  }

  const colorMap = {
    'Hold': 'text-gray-300',
    'To Do': 'text-red-300',
    'Doing': 'text-yellow-300',
    'Done': 'text-green-300',
    
    
  };

  return (
    <div className="flex flex-wrap gap-0.5">
      {['Hold','To Do', 'Doing', 'Done'].map((key) =>
        parsed[key] > 0
          ? [...Array(parsed[key])].map((_, idx) => (
              <FontAwesomeIcon
                key={`${key}-${idx}`}
                icon={faSquare}
                className={`text-[9px] ${colorMap[key]}`}
              />
            ))
          : null
      )}
    </div>
  );
};

  return (
     
    <div className="  ">
      <table className="min-w-full rounded-lg text-xs text-left bg-white  shadow-xl overflow-x-auto">
        <thead className="bg-gray-700 text-white sticky top-0 z-10 shadow-md">
          <tr>
            {[" ","Project id", "Project Name", "Client", "Category", "Manage By","Assignees","Progress","DeadLine"].map((label, idx) => (
              <th
                key={idx}
                className="px-2 py-3 cursor-pointer select-none font-medium uppercase whitespace-nowrap"
                onClick={() => label !== "Members" && handleSort(label.toLowerCase())}
              >
                {label} {sortField === label.toLowerCase() && (sortOrder === "desc" ? "↑" : "↓")}
              </th>
            ))}
            <th className="px-3 py-2 w-12 "></th>
          </tr>
        </thead>
        <tbody>
          {paginatedProjects.map((project, index) => {
           
            return (
              <tr
                key={project.id}
               className={`text-gray-700 border-b border-gray-100 cursor-pointer 
    ${activeRow === project.project_id ? "bg-gray-100" : "hover:bg-gray-50"}`}
  onMouseEnter={() => setActiveRow(project.project_id)}
                onClick={() => navigate(`/${project.project_id}`)}
              >
              <td className='px-4'>
                {(() => {
                  const companyLogoMap = {
                    'IJISEM': IJISEMLogo,
                    'Academic Guru': AcademicGuruLogo,
                    'Leela Greens': LeelagreenLogo,
                    'AGPH': AGPHLogo,
                  };
                  const logo = companyLogoMap[project.company_name];
                  const value = project.company_name;
              
                  if (logo) {
                    const isRunning = projectRunningMap[project.project_id];
                    return isRunning ? (
                      <span className="relative inline-block">
  {/* Pulse rings animation */}
  {[4,5,6,].map((size, index) => (
    <motion.span
      key={index}
      className="absolute inset-0 m-auto rounded-full bg-red-400 opacity-20"
      style={{
        width: `${size * 7}%`,
        height: `${size * 7}%`,
        zIndex: 0,
      }}
      animate={{
        scale: [3,4,5,4,3],
        opacity: [0.2,0.4,0.2],
      }}
      transition={{
        duration: 2,
        ease: "easeInOut",
        repeat: Infinity,
        delay: index * 0.3,
      }}
    />
  ))}

  {/* Logo in center */}
  <img
    src={logo}
    alt={value}
    title={value}
    className="relative z-10 h-6 w-6 rounded-full bg-white"
  />
</span>

                      ) : (
                        <span className="text-gray-500">
                          <img
                            src={logo}
                            alt={value}
                            className="h-6 w-6 rounded-full bg-white"
                            title={value}
                          />
                        </span>
                      );
                    } else {
                      return <span>{value}</span>;
                    }
                  })()}
                </td>
                <td
                className="px-3 py-3 cursor-pointer text-blue-600 hover:underline"
                onClick={(e) => {
                  e.stopPropagation();
                  handleRowClick(project);
                }}
              >
                {project.project_id}
              </td>
                <td className="px-3 py-3">{project.name}</td>
                <td className="px-3 py-3">{project.client}</td>
                
                
                <td className="px-3 py-3">{project.category}</td>
                
                <td className="px-3 py-3">
                  {userprojectOptions.find(u => u.name === project.assign_to)?.name || 'Unknown'}
                </td>
                
                  <td className="pl-3">
                    {project.members.length > 0 && (
                      <span
                        className="inline-flex items-center justify-center w-6 h-6 rounded-full text-xs font-semibold text-gray-700 bg-gray-200"
                        title={project.members.map((m) => userMap[m] || m).join(', ')}
                      >
                        {project.members.length}
                      </span>
                    )}
                  </td>
                  <td className="px-3 py-3 text-sm">
                  {renderTaskStatusSquares(project.no_of_task)}
                </td>
                  <td
  className={`px-3 py-3 transition-all duration-300 ${
    project.submisssion_date &&
    project.status !== "Done" &&
    (() => {
      const today = new Date();
      const submissionDate = new Date(project.submisssion_date);
      const diffInDays = Math.ceil((submissionDate - today) / (1000 * 60 * 60 * 24));

      return diffInDays <= 2 ? 'text-red-600 font-semibold' : '';
    })()
  }`}
>
  {project.submisssion_date
    ? `${new Date(project.submisssion_date).toLocaleDateString('en-GB')}`
    : ''}
</td>


                  <td className="px-3 py-3">
                  <div className="flex items-center space-x-2">
                    <button
                        className="text-gray-600 hover:text-blue-600 border border-gray-300 rounded-[10px] p-1"
                        onClick={(e) => {
                          e.stopPropagation(); // prevents triggering row click
                          handleEdit(project);
                        }}
                    >✏️</button>

                    <button
                      className="text-gray-600 hover:text-red-600 border border-gray-300 rounded-[10px] p-1 px-1"
                      onClick={(e) => {
                        e.stopPropagation(); // prevents triggering row click
                        handleDelete(project.id);
                      }}
                    >🗑️</button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
  {sidebarOpen && (
  <div className="fixed inset-0 z-40  backdrop-blur-sm transition-opacity duration-300">
    <ProjectSidebar
      isOpen={sidebarOpen}
      onClose={() => setSidebarOpen(false)}
      project={selectedProject}
    />
  </div>
)}

      
      <div className="flex justify-between items-center p-3 text-xs bg-gray-50">
        <div>Page <b>{currentPage}</b> of <b>{totalPages}</b></div>
        <div className="flex items-center gap-4">
          <button
            className="text-blue-600 disabled:text-gray-400"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
          >{"<"}</button>
          <button
            className="text-blue-600 disabled:text-gray-400"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
          >{">"}</button>
          <select
            className="border px-1 py-0 rounded"
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            {ITEMS_PER_PAGE_OPTIONS.map((count) => (
              <option key={count} value={count}>{count} / page</option>
            ))}
          </select>
        </div>
      </div>
       
    </div>
  );
};

export default ProjectTableTabs;
